export default __webpack_public_path__ + "static/media/Background_00273.65724806.png";